module.exports = __webpack_public_path__ + "img/convergists2.b1cd3c6d.png";